const config = {
  api: {
    url: 'http://api.mediasourceinn.com/v1',
  },
  cms: {
    url: 'http://www.mediasourceinn.com',
  },
  s3: {
    url: 'http://s3.mediasourceinn.com',
  },
  demo_url: 'https://my-json-server.typicode.com/typicode/demo',
};

export default config;
